import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/img/management/calendar.svg'
import _imports_1 from '@/assets/img/management/add.svg'


const _hoisted_1 = { class: "hasAdminButtonsFooter" }
const _hoisted_2 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "round" }, null, -1)
const _hoisted_4 = { class: "adminButtonContainer" }
const _hoisted_5 = /*#__PURE__*/_createVNode("img", { src: _imports_1 }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_event_card = _resolveComponent("event-card")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.events.length == 0)
      ? (_openBlock(), _createBlock(_component_localized_text, {
          key: 0,
          localizedKey: "app_ancoranientealmomento",
          text: "Ancora niente al momento",
          class: "fs_14 greyBlue d-block ln_12 mt-5 text-center"
        }))
      : _createCommentVNode("", true),
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.events, (item, index) => {
      return (_openBlock(), _createBlock(_component_event_card, {
        key: index,
        event: item,
        onClick: ($event: any) => (_ctx.openEvent(item))
      }, null, 8, ["event", "onClick"]))
    }), 128)),
    _createVNode(_component_router_link, {
      class: "toggleContainer fixedLeftBottom leftActive",
      replace: true,
      to: { name: 'community_calendar' }
    }, {
      default: _withCtx(() => [
        _hoisted_2,
        _hoisted_3
      ]),
      _: 1
    }),
    _createVNode("div", _hoisted_4, [
      (_ctx.$store.state.community.canContent)
        ? (_openBlock(), _createBlock("div", {
            key: 0,
            class: "managementButton ms-2",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.newEvent()))
          }, [
            _hoisted_5
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}